import React from 'react';
import styled from 'styled-components';

import FireworkSvgPath from '../media/firework.svg';

import {pxToEm} from './globalStyles';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledBackgroundDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(120.85deg, #001839 0%, #1f467a 98.31%);
  z-index: -1;
  overflow: hidden;
`;

const StyledFireworkImg = styled.img<{placement: FireworkPlacement}>`
  position: absolute;
  width: ${props => props.placement.width || DEFAULT_FIREWORK_PLACEMENT.width};
  min-width: ${props => props.placement.minWidth || DEFAULT_FIREWORK_PLACEMENT.minWidth};
  top: ${props => props.placement.top || 'auto'};
  right: ${props => props.placement.right || 'auto'};
  bottom: ${props => props.placement.bottom || 'auto'};
  left: ${props => props.placement.left || 'auto'};
`;

//#endregion

interface FireworkPlacement {
  width?: string;
  minWidth?: string;
  top?: string;
  right?: string;
  left?: string;
  bottom?: string;
}

const DEFAULT_FIREWORK_PLACEMENT: FireworkPlacement = {
  width: '100%',
  minWidth: `${pxToEm(400)}em`,
  top: '-10%',
  right: '0'
};

interface Props {
  className?: string;
  fireworks?: FireworkPlacement[];
}

const BlueFireworkPanel: React.FunctionComponent<Props> = ({
  className,
  fireworks = [DEFAULT_FIREWORK_PLACEMENT],
  children
}) => (
  <StyledWrapperDiv className={className}>
    <StyledBackgroundDiv>
      {fireworks.map((fireworkPlacement, i) => (
        <StyledFireworkImg key={`firework-${i}`} placement={fireworkPlacement} src={FireworkSvgPath} alt="Firework" />
      ))}
    </StyledBackgroundDiv>
    {children}
  </StyledWrapperDiv>
);

export default BlueFireworkPanel;
